import { UseModalProps } from '@chakra-ui/react'
import { nanoid } from 'nanoid'

import { wwtModalManagerLog } from '../logger/wwtModalManagerLog.ts'
import {
	ModalInfo,
	ModalPriority,
	ModalProps,
	ModalTypes
} from '../types/modalTypes.ts'

export const generateNewModalInfo = <T extends ModalTypes>(
	type: T,
	props?: ModalProps[T],
	priority = ModalPriority.default,
	modalProps?: Partial<UseModalProps>,
	idPrefix = ''
) => {
	wwtModalManagerLog(
		'Generate new modal info',
		type,
		props,
		priority,
		modalProps
	)

	const modalId = idPrefix + nanoid()

	const modalInfo: ModalInfo<typeof type> = {
		id: modalId,
		type,
		props,
		priority,
		modalProps,
		childModals: []
	}

	wwtModalManagerLog('Generated modal', JSON.stringify(modalInfo))

	return modalInfo
}
